import {SpaceProto} from "../space-proto"
import {NavigationSectionConfig, NavigationSectionType} from "../../navigation/@const"
import Navigation_ButtonGenericDeprecated from "../../../../layout/navigation/buttons/generic-section"
import NavigationMenu_Projects from "../../../../layout/menu/sections/projects/menu-projects"
import NavigationMenu_ProjectsCustomer from "../../../../layout/menu/sections/projects/menu-projects-customer"
import {getNavigationPosition} from "../../navigation/functions/get-navigation-position"
import {navigationStructureOnClick} from "../../navigation/actions/navigation-structure-on-click"
import ProjectSession from "../../project/project-session"
import NavigationMenuSearch from "../../../../layout/search/sections/navigation-menu/navigation-menu-search"
import {GroupedData} from "../../../data-structures/group"
import mainMenu_projectViews from "../../../../layout/menu/actions/project-views"
import {ProjectSystemType} from "../../project/types"
import NavigationMenu_ProjectsContent from "../../../../layout/menu/sections/projects/menu-content";

// const debug = "SpaceProjects"
const debug = false

export class SpaceProjects extends SpaceProto {

    private isEnabled: boolean = false

    constructor() {
        super(NavigationSectionType.PROJECTS)

        this.updateEnabled()

        this.title              = "Projects"
        this.canHaveProjects    = true
        this.icon               = 'ii5-project'
        this.svgIcon            = 'isvg-projects'
    }

    onClick = () => {
        navigationStructureOnClick(this.navigation)
    }

    get enabled():boolean {
        debug && console.log(debug, "enabled() isEnabled=", this.isEnabled)
        return this.isEnabled
    }

    get navigationStructureConfig():NavigationSectionConfig {

        return {
            id              : this.id,
            icon            : "i5-nav-projects",
            iconActive      : "i5-nav-projects-solid",
            hint            : gd.t('menu.projects.hint'),
            keyboardShortcut: 'P',
            renderComponent : Navigation_ButtonGenericDeprecated,
            type            : NavigationSectionType.PROJECTS,
            menuComponent   : gd.user.isCustomer() ? NavigationMenu_ProjectsCustomer : NavigationMenu_Projects,
            menuContent     : NavigationMenu_ProjectsContent,
            onClick         : this.onClick,
            position        : getNavigationPosition(NavigationSectionType.PROJECTS),
        }

    }

    // is required to represent projects workspace in various lists/trees
    get project() {
        return new ProjectSession({
            id          : 'projects',
            name        : this.title,
            projectIcon : 'project',
            systemType  : ProjectSystemType.WORKSPACE,
        })
    }

    get rootProjects() {

        return gd.session.projects.treeRootsNotWorkspaces


        // const rootProjects = _.filter(gd.session.projects.treeRootsNotWorkspaces, (project: ProjectSession )=>
        //
        //     && (!starredProjects || !starredProjects.includes(project.id))
        // )

    }

    get sections() {
        return gd.session.projects.treeRootsSections
    }

    get menuResourcesCounter() {
        // make sure we do not show root projects which are starred
        const starredProjects : ID[] = gd.session.starredItems.getProjectsIds() || []
        const workspaceRootProjects = _.filter(this.rootProjects, (project:ProjectSession)=>{
            return !starredProjects.includes(project.id)
        })
        return workspaceRootProjects.length
    }

    async search(keyword: string): Promise<GroupedData> {
        const rootProjects = gd.session.projects.treeRoots
        const rootProjectIds = rootProjects.filter((project: ProjectSession)=>{
            if(!project.isWorkspace && !project.isDeleted && !project.isTag){
                return true
            }
        }).map(project => project.id)

        const rootTags = gd.session.projects.rootTags

        const projectViews = mainMenu_projectViews()

        return await new NavigationMenuSearch(keyword, this).search(rootProjectIds, [], [], projectViews, rootTags)
    }

    updateEnabled() {
        this.isEnabled = gd.session.projects.companyHasNoProjects || gd.session.projects.hasProjectsOutsideOfWorkspace
   }
}
